import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import * as React from 'react';
import styled from 'styled-components';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getLiveCatalogStatus } from '@/redux/modules/console';
import {
    getItemSummaryFirstImageUrl,
    getItemSummaryTitle,
    getItemSummaryUrl,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { addImageParams } from '@/utils/urls';

type Props = {
    catalogId: number;
    itemId: number;
    showLive: boolean;
};

const CurrentItemLink = ({ catalogId, itemId, showLive }: Props) => {
    const catalogTitle = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const liveCatalogStatus = useAppSelector((state) => getLiveCatalogStatus(state, catalogId));
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const itemUrl = useAppSelector((state) => getItemSummaryUrl(state, itemId));

    const saleFinished = liveCatalogStatus === 'done';
    const saleLive = liveCatalogStatus === 'live' || liveCatalogStatus === 'paused' || showLive;

    const firstPhoto = useAppSelector((state) => getItemSummaryFirstImageUrl(state, itemId));
    const imageUrl = addImageParams({ url: firstPhoto, width: 375 });

    return (
        <RouteLink
            className="flex h-full cursor-pointer items-center justify-center"
            to={itemUrl}
        >
            <LiveItemImage
                alt={title}
                src={imageUrl}
            />
            {!saleLive && (
                <WaitingToStartContainer>
                    {saleFinished ? (
                        <FormattedMessage
                            id="bidding_console.done.title"
                            values={{ title: catalogTitle }}
                        />
                    ) : (
                        <>
                            <FormattedMessage id="bidding_console.wait.title" />
                            <Loading />
                        </>
                    )}
                </WaitingToStartContainer>
            )}
        </RouteLink>
    );
};

export default CurrentItemLink;

const LiveItemImage = styled.img`
    max-height: 100%;
    max-width: 100%;
    z-index: 1;
    position: relative;
`;

const WaitingToStartContainer = styled.div`
    background: ${({ theme }) => theme.colors.white};
    font-size: 20px;
    padding: 15px;
    position: absolute;
    top: 50%;
    z-index: 2;
    border-radius: 4px;
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.shadowOverlay200};
    width: calc(100% - 20px);
    text-align: center;
`;
